export default {
	address: 'Adres',
	addToCart: 'Toevoegen aan mandje',
	belgium: 'België',
	cart: 'Mandje',
	city: 'Woonplaats',
	country: 'Land',
	currentPage: 'huidige',
	deliveryDate: 'Leverdatum',
	deliveryFormat: '[Week] w YYYY',
	email: 'E-mailadres',
	eta: 'ETA:',
	etaFormat: '[Week] w',
	firstEta: 'Eén of meerdere artikelen zijn op dit moment niet op voorraad. De eerst mogelijke leverdatum is {{week}}.',
	firstEtaFallback: 'unbekend',
	firstEtaFormat: '[week] w',
	friend: 'Wie ken ik bij PTMD?',
	germany: 'Duitsland',
	itemNotFound: 'Item niet gevonden',
	itemUnavailable: 'Dit item is niet op voorraad',
	name: 'Naam',
	netherlands: 'Nederland',
	oops: 'Oeps...',
	order: 'Plaats bestelling',
	orderDetails: 'Order details',
	phone: 'Telefoonnummer',
	placeWishlist: 'Plaats wishlist',
	pleaseTilt: 'Gelieve uw scherm te draaien.',
	postalCode: 'Postcode',
	stock: 'Voorraad: {{count}}',
	'stock_interval': '(999999){Voorraad: Binnenkort beschikbaar};',
	thanksForYourOrder: 'Bedankt voor het plaatsen van uw Click&Collect bestelling. Uw wishlist wordt nu naar {{customer}} verzonden. {{customer}} zal zo spoedig mogelijk contact met u opnemen.',
	toggleFullScreen: 'Toggle fullscreen',
	total: 'Totaal:',
	useSafari: 'Gelieve Safari te gebruiken.',
	yourShop: 'Uw winkel: {{customer}}'
};
